import { useFewshot, useSetFewshotFlags } from './queries'
import styles from './studio.module.css'

type Props = {
  readonly cardId: string
  readonly cardName: string
  readonly limit: number
}

export function LibraryCard({ cardId, cardName, limit }: Props) {
  const list = useFewshot(cardId)
  const flags = useSetFewshotFlags()
  const items = list.data?.items ?? []
  const inUse = new Set(items.filter((i) => !i.excluded).slice(0, limit).map((i) => i.id))

  return (
    <section className={styles.library} aria-live="polite">
      <h2>
        {cardName} <span className="muted">· эталонов {list.data?.total ?? 0}</span>
      </h2>
      {list.isPending && <div className="spinner" aria-label="Загрузка" />}
      {list.isError && <p className="error-box">Не удалось загрузить эталоны карты.</p>}
      {list.data && items.length === 0 && (
        <p className="muted">Эталонов пока нет. Сгенерируйте разбор в песочнице и сохраните удачный вариант.</p>
      )}
      {flags.error && (
        <p className="error-box">{flags.error instanceof Error ? flags.error.message : 'Не удалось изменить эталон'}</p>
      )}
      {items.map((item) => (
        <article key={item.id} className={`${styles.example} ${item.excluded ? styles.exampleExcluded : ''}`}>
          <div className={styles.exampleHead}>
            <div>
              {inUse.has(item.id) && <span className="badge ok">в подсказке</span>}
              {item.pinned && <span className="badge">закреплён</span>}
              {item.excluded && <span className="badge danger">исключён</span>}
              {item.rating != null && <span className="badge">оценка модели {item.rating}/5</span>}
            </div>
            <span className="muted">
              {new Date(item.created_at).toLocaleDateString('ru-RU')} · {item.model ?? '—'} · {item.prompt_version ?? '—'}
            </span>
          </div>
          <div className="transcript">{item.expert_output}</div>
          {item.comment && <p className="muted">{item.comment}</p>}
          <div className="row">
            <button
              className="secondary"
              disabled={flags.isPending || item.excluded}
              onClick={() => flags.mutate({ id: item.id, flags: { pinned: !item.pinned } })}
            >
              {item.pinned ? 'Открепить' : 'Закрепить'}
            </button>
            <button
              className={item.excluded ? 'secondary' : 'danger'}
              disabled={flags.isPending}
              onClick={() => flags.mutate({ id: item.id, flags: { excluded: !item.excluded } })}
            >
              {item.excluded ? 'Вернуть в подсказку' : 'Исключить'}
            </button>
          </div>
        </article>
      ))}
    </section>
  )
}
